import { render, staticRenderFns } from "./PageTree.vue?vue&type=template&id=b0166bb8&"
import script from "./PageTree.vue?vue&type=script&lang=js&"
export * from "./PageTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports